import { useState } from 'react';
import * as R from 'ramda';
import { getModelName, getNoise, getVolume } from '../Services/ValueTransform';

const Exporter = ({ selecteds, handleDeselect, handlePreview }) => {
  return (
    // <div class='py-6'>
    <div
      class='relative overflow-x-auto'
      style={{
        marginTop: 50,
        paddingTop: 10,
        width: '100%',
        borderTop: '1px solid rgb(10 161 149 / var(--tw-bg-opacity))',
      }}
    >
      <table class='min-w-full divide-y divide-gray-200 dark:divide-gray-700'>
        <thead>
          <tr
            class='divide-x divide-gray-200 dark:divide-gray-700'
            style={{ background: '#7d8ec1' }}
          >
            <th
              scope='col'
              class='px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase'
            >
              #
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase'
            >
              Model
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase'
            >
              Volume
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase'
            >
              T.P
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
            >
              S.P
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
            >
              RPM
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
            >
              D.Eff
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
            >
              Noise
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
            >
              Velocity
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
            >
              S.Power
            </th>
            <th
              scope='col'
              class='px-6 py-3 text-end text-xs font-medium text-gray-500 uppercase'
            >
              Rec.Pow
            </th>
          </tr>
        </thead>
        <tbody class='divide-y divide-gray-200 dark:divide-gray-700'>
          <tr style={{ background: '#b3bcdb' }}>
            <td class='px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200'></td>
            <td class='px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200'></td>
            <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
              -
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
              Pa
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
              Pa
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
              r/min
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
              %
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
              dB(A)
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
              m/s
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
              kW
            </td>
            <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
              kW
            </td>
          </tr>
          {selecteds.map((fan) => (
            <tr
              onDoubleClick={() => handlePreview(fan)}
              style={{ cursor: 'pointer' }}
            >
              <td class='px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200'>
                <div
                  className='xclose'
                  onClick={() => handleDeselect(fan)}
                ></div>
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-sm font-medium text-gray-800 dark:text-gray-200'>
                {getModelName(fan, fan.configs.modelTypeSelect)}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
                {getVolume(fan, fan.configs)}{' '}
                {fan.configs.volumeType == 1 ? ' m3/h' : ' l/s'}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-sm text-gray-800 dark:text-gray-200'>
                {fan.fan_total_pressure}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                {fan.fan_static_pressure}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                {fan.fan_speed / 100}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                {fan.fan_total_efficiency.toFixed(2) / 100}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                {getNoise(fan, fan.configs)}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                {fan.fan_outlet_velocity.toFixed(2) / 100}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                {fan.fan_shaft_power.toFixed(2) / 100}
              </td>
              <td class='px-6 py-1 whitespace-nowrap text-end text-sm font-medium'>
                {fan.motor_power_origin}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    // </div>
  );
};
export default Exporter;
